export default __webpack_public_path__ + "static/media/coinYellow.8f66742b.svg";